import React from 'react';

const Header = () => {
    const isMobile = window.innerWidth < 768
    const kitlegit = require("../assets/images/wv_logo_written.png")
    const k = require("../assets/images/wv_logo.png")
    return (
        <div className={isMobile ? 'header-container center' : 'header-container align'}>
            {
                !isMobile && <img className='logo-k'  src={k} alt="\"/>
            }
            <img className='logo-written'  src={kitlegit} alt="\"/>
        </div>
    )
}

//check/XXXX00800XX106X1A1706813835004466

export default Header